// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-map-detail-panel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: min(48%, 200px);
    overflow: auto;
    padding: 10px 12px 12px;
    border-radius: 8px 8px 0 0;
    background: rgba(18, 22, 28, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: none;
    box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.35);
    z-index: 2;
}

.audit-map-detail-panel__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 8px;
}

.audit-map-detail-panel__title {
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #c0a053;
    line-height: 1.3;
}

.audit-map-detail-panel__close {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    margin: -4px -6px 0 0;
    border: none;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    color: #ccc;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
}

.audit-map-detail-panel__close:hover {
    background: rgba(192, 159, 83, 0.2);
    color: #fff;
}

.audit-map-detail-panel__empty {
    margin: 0;
    font-size: 0.75rem;
    color: #777;
    line-height: 1.4;
}

.audit-map-detail-panel__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.audit-map-detail-panel__item {
    font-size: 0.72rem;
    line-height: 1.4;
    color: #c8c8c8;
    padding: 6px 8px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.25);
    border-left: 3px solid #666;
}

.audit-map-detail-panel__item--info {
    border-left-color: rgba(140, 180, 220, 0.85);
}

.audit-map-detail-panel__item--watch {
    border-left-color: rgba(230, 175, 80, 0.9);
}

.audit-map-detail-panel__item--risk {
    border-left-color: rgba(235, 110, 110, 0.9);
}

.audit-map-detail-panel__code {
    display: block;
    font-size: 0.62rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #888;
    margin-bottom: 3px;
}

.audit-map-detail-panel__text {
    display: block;
}

.audit-map-detail-panel__hint {
    margin: 8px 0 0;
    font-size: 0.65rem;
    color: #666;
    line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AuditSnapshotCard/AuditMapDetailPanel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".audit-map-detail-panel {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    max-height: min(48%, 200px);\n    overflow: auto;\n    padding: 10px 12px 12px;\n    border-radius: 8px 8px 0 0;\n    background: rgba(18, 22, 28, 0.96);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-bottom: none;\n    box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.35);\n    z-index: 2;\n}\n\n.audit-map-detail-panel__head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.audit-map-detail-panel__title {\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #c0a053;\n    line-height: 1.3;\n}\n\n.audit-map-detail-panel__close {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    margin: -4px -6px 0 0;\n    border: none;\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.08);\n    color: #ccc;\n    font-size: 1.25rem;\n    line-height: 1;\n    cursor: pointer;\n}\n\n.audit-map-detail-panel__close:hover {\n    background: rgba(192, 159, 83, 0.2);\n    color: #fff;\n}\n\n.audit-map-detail-panel__empty {\n    margin: 0;\n    font-size: 0.75rem;\n    color: #777;\n    line-height: 1.4;\n}\n\n.audit-map-detail-panel__list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.audit-map-detail-panel__item {\n    font-size: 0.72rem;\n    line-height: 1.4;\n    color: #c8c8c8;\n    padding: 6px 8px;\n    border-radius: 6px;\n    background: rgba(0, 0, 0, 0.25);\n    border-left: 3px solid #666;\n}\n\n.audit-map-detail-panel__item--info {\n    border-left-color: rgba(140, 180, 220, 0.85);\n}\n\n.audit-map-detail-panel__item--watch {\n    border-left-color: rgba(230, 175, 80, 0.9);\n}\n\n.audit-map-detail-panel__item--risk {\n    border-left-color: rgba(235, 110, 110, 0.9);\n}\n\n.audit-map-detail-panel__code {\n    display: block;\n    font-size: 0.62rem;\n    font-weight: 800;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #888;\n    margin-bottom: 3px;\n}\n\n.audit-map-detail-panel__text {\n    display: block;\n}\n\n.audit-map-detail-panel__hint {\n    margin: 8px 0 0;\n    font-size: 0.65rem;\n    color: #666;\n    line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
